export default function StreamInputDescHttpPull({ input }) {
  return <>HTTP/TS {input.url}</>;
}
